//# sourceMappingURL=my-marked-dates.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module id = 966
// module chunks = 33